__turbopack_context__.v({
  "container": "styles-module__lupi3a__container",
  "hoverContainer": "styles-module__lupi3a__hoverContainer",
  "hoverContainerActive": "styles-module__lupi3a__hoverContainerActive",
  "menuList": "styles-module__lupi3a__menuList",
  "menuListItem": "styles-module__lupi3a__menuListItem",
  "menuListItemButton": "styles-module__lupi3a__menuListItemButton",
  "navCategoryListNarrow": "styles-module__lupi3a__navCategoryListNarrow",
  "navCategoryListWide": "styles-module__lupi3a__navCategoryListWide",
});
